<template>
  <layout>
    <div slot="banner"></div>
    <div class="empty-box"></div>

    <!-- 介绍 -->
    <Introduction
      :data="data.introduction"
    />

    <div class="ai">
      <div class="layout-content">
        <div class="title-wrap">
          <SubTitle :text="data.ai.title" :subText="data.ai.subTitle" />
        </div>

        <Columns :data="data.ai" />
      </div>
    </div>

    <div class="blockchain section">
      <div class="layout-content">
        <div class="title-wrap">
          <SubTitle :text="data.blockchain.title" :subText="data.blockchain.subTitle" />
        </div>

        <Columns :data="data.blockchain" theme="deeppink" />
      </div>
    </div>
  </layout>
</template>

<script>
import layout from '../../components/layout/layout'
import Columns from './columns'
import SubTitle from '../../components/SubTitle'
import Introduction from '../../components/Introduction'

import { mapState } from 'vuex'

export default {
  name: 'Past2021',

  components: {
    layout,
    Columns,
    SubTitle,
    Introduction
  },

  computed: {
    ...mapState([
      'isEnLang',
      'isMobile'
    ]),
    data () {
      return this.$t('past2021')
    }
  }
}
</script>

<style lang="scss" scoped>

// .section {
//   padding-top: 32px;
//   padding-bottom: 32px;
// }

.ai {
  padding-top: 120px;
  background: $bgGrey;

  @include mobile {
    padding-top: 50px;
  }

  .layout-content {
    position: relative;
    z-index: 10;
  }

  & .img-l {
    position: absolute; right: 0; top: 0;
    width: 630px;
  }
  & .img-r {
    position: absolute; left: 0; bottom: 0;
    width: 500px;
  }
}

.blockchain {
  padding: 120px 0 200px;
  background: $bgGrey;

  @include mobile {
    padding: 50px 0;
  }
}

.title-wrap {
  margin-bottom: 20px;
}

.empty-box {
  width: 100vw; height: 68px;

  @include mobile {
    height: 55px;
  }
}

</style>
